import styled from 'styled-components'
import RightButtonsTopBox, { RightButtonsTopBoxProps } from './rightButtonsTopBox.component'

const Wrapper = styled.aside`
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;

  display: flex;

  height: 40px;
  width: 40px;

  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadow(1)};

  background-color: white;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: ${({ theme }) => theme.backdropBackground};
    -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
    backdrop-filter: ${({ theme }) => theme.backdropFilter};
  }
`

export default function RightButtons({
  onChangeMapType,
  mapType,
  onChangeMap3DOption,
  map3DOption,
  layers,
  baseLayers,
  variables,
  setBaseLayers,
  styles,
  children,
  setIsSomethingLoading,
}: RightButtonsTopBoxProps) {
  return (
    <Wrapper>
      <RightButtonsTopBox
        onChangeMapType={onChangeMapType}
        mapType={mapType}
        onChangeMap3DOption={onChangeMap3DOption}
        map3DOption={map3DOption}
        layers={layers}
        baseLayers={baseLayers}
        variables={variables}
        setBaseLayers={setBaseLayers}
        styles={styles}
        children={children}
        setIsSomethingLoading={setIsSomethingLoading}
      />
    </Wrapper>
  )
}
